export default __webpack_public_path__ + "static/media/location-marker.inline.7fd76d9b.svg";